module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4QwECjEchJXG+gAAAN1JREFUWMNjYBgFQw3839D2//+Gtv/UMo+FFItp4SEmSkKCGg5gpNQixoAqxgEJAWqFBE4HTNkfokSs4ejq/v//L4NVHEsCxumA7I9Gd8kNCUZGxifEOp6JWsGKnBaQ9f/f0Pb/4dtzAUQ7gKw49a/Uxqdf7vCO9UQ5gNwExcjIeI2UKHr24bochgPIthxH0JOUCwbKcqqUA1SpC9BLM2y+ganBJkeq76UENB8NrhCgZpGLLaTwhd6AhwATKSme0pqPoiigJKrwRd/wS4SDpiAiNs0MnVwwbB0wCkYBAEifhrI1zqZsAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/captadas_bi_sin.png
// module id = aQxl
// module chunks = 0